import React,{Component} from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import {createMarkup} from './Factory';
import {UISref} from 'ui-router-react'; 

class AusstellungenItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			animateClass : 'fadeOut'
		}	
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.setState({ animateClass : 'fadeIn' });
		}
	}
	render(){
		const {title,slug='',image_data,exhibition_start_date,exhibition_end_date} = this.props;
		let {image:imgUrl,title:image_title,alt,image_tiny} = image_data;
		let divStyle = {
				backgroundImage: 'url(' + imgUrl + ')',
				backgroundSize: 'cover',
				maxWidth: '100%',
		}		
		return(
			<VisibilitySensor partialVisibility={true} onChange={this.onChange} >
				<article className={`article-item col-md-4 ${this.state.animateClass}`}>
				   <UISref to="root.programm.ausstellungendetails" params={{item:slug}}>
					   <a>	
							<div className="fixed-ht-img ratio-news">
                                <div title={image_title} className="img-wrapper"  style={divStyle}>
                                </div>
							</div>
							<h1 className="h2" dangerouslySetInnerHTML={createMarkup(title.rendered)}></h1>
							<div className="times">
								<span className="event-start">{exhibition_start_date}</span>
								<span className="event-end"> - {exhibition_end_date}</span>
							</div>
						</a>
					</UISref>
				</article>
			</VisibilitySensor>
		)
	}
}
export default AusstellungenItem;


// WEBPACK FOOTER //
// ./src/components/AusstellungenItem.js